import { requests } from "./apiUtils";

const addressUrl = "https://app.travelopenmap.com/api";

const CACHE = {};

export function get({ path, params }: any) {
  return requests({
    method: "GET",
    url: `${addressUrl}${path}`,
    headers: {},
    params,
  });
}

export const getCountries = async (keywords: string) => {
  const cacheKey = "countries";
  if (!CACHE[cacheKey]) {
    const { data } = await get({ path: `/countries` });
    CACHE[cacheKey] = data;
  }
  const countries = CACHE[cacheKey]
    .filter((item: any) => item.name.includes(keywords) || keywords == "")
    .map((item: any) => ({ label: item.name, value: item.code }));
  return Promise.resolve(countries);
};

export const getStates = async (country: string, keywords: string) => {
  const cacheKey = `state_${country}`;
  if (!CACHE[cacheKey]) {
    const { data } = await get({ path: `/countries/${country}/states` });
    CACHE[cacheKey] = data;
  }
  const states = CACHE[cacheKey]
    .filter((item: any) => item.name.includes(keywords) || keywords == "")
    .map((item: any) => ({ label: item.name, value: item.code }));
  return Promise.resolve(states);
};

export const getCities = async (country: string, state: string, keywords: string) => {
  const cacheKey = `city_${country}_${state}`;
  if (!CACHE[cacheKey]) {
    const { data } = await get({
      path: `/countries/${country}/states/${state}/cities`,
    });
    CACHE[cacheKey] = data;
  }
  const cities = CACHE[cacheKey]
    .filter((item: any) => item.name.includes(keywords) || keywords == "")
    .map((item: any) => ({ label: item.name, value: item.code }));
  return Promise.resolve(cities);
};
